import { getQueryParam } from "../util/getUrlParam";
import { platformAdpter } from "../util/adpter";
import { ClientSdk, createSdkFactory, IncentiveVideoResult, PayModel, PayOrderEnum, SdkUserPlatform, StatEventEnum, StatModel } from "./ClientSdk";
import { AppException } from "../util/exception";
import { GetPromiseType } from "../util/types";

export const getRequestData = (action: string, data = {}) => ({
    action,
    data: JSON.stringify(data),
});

export class FanjuSdk implements ClientSdk {
    refreshProduct(): void {
        throw new Error('喵喵方法，不实现');
    }

    async incentiveVideo() {
        const payload = {
            action: 'incentiveVideo',
        };
        const method = (
            resolve: ((value: IncentiveVideoResult | PromiseLike<IncentiveVideoResult>) => void),
            reject: (error: AppException) => void,
        ) => ({
            onSuccessCallback(jsonMsg: string) {
                const json = JSON.parse(jsonMsg) as {data: IncentiveVideoResult};
                resolve(json.data);
            },
            onFailCallback(jsonMsg: string) {
                const json = JSON.parse(jsonMsg) as {data: IncentiveVideoResult};
                reject(new AppException(json.data.msg));
            },
        });

        return platformAdpter<ReturnType<ClientSdk['incentiveVideo']>>({
            ios: function () {
                return new Promise((resolve, reject) => {
                    createSdkFactory(
                        data => window.webkit.messageHandlers.webToNative.postMessage(data),
                        payload,
                        method(resolve, reject),
                    )
                });
            },
            android: function() {
                return new Promise((resolve, reject) => {
                    createSdkFactory(
                        data => window.callNative.evaluateJsToNative(data),
                        payload,
                        method(resolve, reject),
                    )
                });
            },
            harmony: function () {
                return new Promise((resolve, reject) => {
                    createSdkFactory(
                        data => window.callNative.evaluateJsToNative(data),
                        payload,
                        method(resolve, reject),
                    )
                });
            }
        });
    }

    event<R>(eventId: StatEventEnum, param: R) {
        const payload = {
            action: 'ssAgentEvent',
            data: {
                key: eventId,
                map: param,
            },
        };
        return platformAdpter<ReturnType<ClientSdk['event']>>({
            ios: function () {
                return createSdkFactory(
                    data => window.webkit.messageHandlers.webToNative.postMessage(data),
                    payload,
                );
            },
            android: function() {
                return createSdkFactory(
                    data => window.callNative.evaluateJsToNative(data),
                    payload,
                );
            },
            harmony: function () {
                return createSdkFactory(
                    data => window.callNative.evaluateJsToNative(data),
                    payload,
                );
            }
        });
    }

    /**
     * 客户端联系微信
     * @param model 
     * @returns 
     */
    toContactWX(url: string) {
        return platformAdpter<ReturnType<ClientSdk['toContactWX']>>({
            async ios() {
                return createSdkFactory(
                    data => window.webkit.messageHandlers.webToNative.postMessage(data),
                    {
                        action: 'joinWeixin',
                        data: {
                            url,
                            corpid: 'wwdcc2b1cda6e600e8',
                        },
                    },
                );
            },
            async android() {
                window.android.jumpWxCustomerService(url);
            },
            async harmony()  {
                const iframe = document.createElement('iframe');
                iframe.width = '0px';
                iframe.height = '0px';
                iframe.style.overflow = 'hidden';
                iframe.src = url;
                document.body.appendChild(iframe);
                setTimeout(() => {
                    iframe.src = '';
                    document.body.removeChild(iframe);
                }, 1000);
            },
        });
    }
    /**
     * 客户端埋点
     * @param model 
     * @returns 
     */
    async stat(model: StatModel) {
        return platformAdpter<ReturnType<ClientSdk['stat']>>({
            ios: async () => {
                createSdkFactory(
                    data => window.webkit.messageHandlers.webToNative.postMessage(data),
                    {
                        action: 'clickEvent',
                        data: {
                            page: model.pageKey,
                            target: model.target,
                            action: model.action,
                            options: model.actionParams,
                        },
                    },
                );
            },
            android: async () => {
                createSdkFactory(
                    () => window.android.addStat(model.pageKey, model.target, String(model.action), model.actionParams || ''),
                );
            },
            harmony: async () => {
                createSdkFactory(
                    () => window.android.addStat(model.pageKey, model.target, String(model.action), model.actionParams || ''),
                );
            },
        });
    };
    async payOrder(model: PayModel) {       
        const method = (
            resolve: ((value: GetPromiseType<ReturnType<ClientSdk['payOrder']>> | PromiseLike<GetPromiseType<ReturnType<ClientSdk['payOrder']>>>) => void),
        ) => ({
            onSuccessCallback() {
                resolve({
                    status: PayOrderEnum.SUCCESS,
                    success: () => true, 
                });
            },
            onFailCallback() {
                resolve({
                    status: PayOrderEnum.FIALED,
                    success: () => false, 
                });
            },
        });

        return platformAdpter<ReturnType<ClientSdk['payOrder']>>({
            async ios() {
                const payQuery = {
                    shopId: model.shopId,
                    productId: model.productId,
                    payMethod: model.payMethod,
                };
                return new Promise<GetPromiseType<ReturnType<ClientSdk['payOrder']>>>(resolve => {
                    return createSdkFactory(
                        data => window.webkit.messageHandlers.webToNative.postMessage(data),
                        {
                            action: 'sendPayRequest',
                            data: payQuery,
                        },
                        method(resolve),
                    );
                });
            },
            android() {
                return new Promise(resolve => {
                    createSdkFactory(
                        () => {
                            window.android.sendPayRequest(String(model.shopId), String(model.payMethod), '', '');
                        },
                        null,
                        method(resolve),
                    );
                });
            },
            async harmony() {
                return new Promise(resolve => {
                    createSdkFactory(
                        () => {
                            window.android.sendPayRequest(String(model.shopId), String(model.payMethod), '', '');
                        },
                        null,
                        method(resolve),
                    );
                });
            },
        });
    }
    // 加载用户信息
    async loadUser() {
        return platformAdpter<ReturnType<ClientSdk['loadUser']>>({
            ios: async () => ({
                id: getQueryParam('userId') || '',
                hashId: '',
                activityId: getQueryParam('id') || '',
                name: '',
                cover: '',
                platform: SdkUserPlatform.Ios,
                deviceModel: '',
                manufacturer: '',
                app_version: '',
                deviceVersion: '',
                idfa: '',
                oaid: '',
                token: '',
            }),
            android: async () => ({
                id: getQueryParam('userId') || '',
                hashId: '',
                activityId: getQueryParam('id') || '',
                name: '',
                cover: '',
                platform: SdkUserPlatform.Android,
                deviceModel: '',
                manufacturer: '',
                app_version: '',
                deviceVersion: '',
                idfa: '',
                oaid: '',
                token: '',
            }),
            harmony: async () => ({
                id: getQueryParam('userId') || '',
                hashId: '',
                activityId: getQueryParam('id') || '',
                name: '',
                cover: '',
                platform: SdkUserPlatform.Harmony,
                deviceModel: '',
                manufacturer: '',
                app_version: '',
                deviceVersion: '',
                idfa: '',
                oaid: '',
                token: '',
            }),
        });
    };

    // 用户分享
    async shared() {
        return platformAdpter<ReturnType<ClientSdk['shared']>>({
            ios: async () => { },
            android: async () => { },
            harmony: async () => { },
        });
    };
    

    // 退出页面
    async backWeb() {
        return platformAdpter<ReturnType<ClientSdk['backWeb']>>({
            ios: async () => {
                createSdkFactory(
                    data => window.webkit.messageHandlers.webToNative.postMessage(data),
                    {
                        action: 'goBack',
                    }
                );
            },
            android: async () => {
                createSdkFactory(
                    () => window.android.handBackClick()
                );
            },
            harmony: async () => {
                createSdkFactory(
                    () => window.android.handBackClick(),
                );
            },
        });
    };
}